"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimAnalyticsHeader = void 0;
const button_1 = require("client/components/material/button");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const select_1 = require("client/components/material/select");
const switch_1 = require("client/components/material/switch");
const modal_1 = require("client/components/modal");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/reporting/store");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const store_3 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const react_1 = require("react");
const React = require("react");
const claim_1 = require("shared/claim");
const throttle_debounce_1 = require("throttle-debounce");
const multi_select_1 = require("client/components/ui/multi-select");
require("./claim-analytics-header.less");
let ClaimAnalyticsHeader = class ClaimAnalyticsHeader extends react_1.Component {
    constructor() {
        super(...arguments);
        this.claimStatuses = [
            {
                id: 0,
                label: "All Claims",
                value: claim_1.ClaimStatus.All
            },
            {
                id: 1,
                label: "Dispensed",
                value: claim_1.ClaimStatus.Dispensed
            },
            {
                id: 2,
                label: "Reversed",
                value: claim_1.ClaimStatus.Reversed
            },
            {
                id: 3,
                label: "Error",
                value: claim_1.ClaimStatus.Error
            },
            {
                id: 5,
                label: "Intended",
                value: claim_1.ClaimStatus.Intended
            },
            {
                id: 6,
                label: "New",
                value: claim_1.ClaimStatus.New
            },
            {
                id: 7,
                label: "Approved",
                value: claim_1.ClaimStatus.Paid
            },
            {
                id: 11,
                label: "Reverse Error",
                value: claim_1.ClaimStatus.ReverseError
            },
            {
                id: 12,
                label: "ERX Server Error",
                value: claim_1.ClaimStatus.ReverseErrorDev
            } // B-094 B-094.2
        ].sort((a, b) => (a.label > b.label ? 1 : -1));
        this.filterText = "";
        this.filterDate = "";
        this.siteId = [0]; // E-031
        // public siteId: number = 0;
        this.selectedValue = [];
        this.startDate = "";
        this.endDate = "";
        this.cashClaimsOnly = false;
        this.showDisabledSites = false;
        this.claimStatus = claim_1.ClaimStatus.All;
        this.headerToggle = () => {
            store_1.reportsStore.editModal = !store_1.reportsStore.editModal;
            if (this.showDisabledSites) {
                this.showDisabledSites = false;
                store_2.sitesListStore.loadSitesNoRelation();
            }
        };
        this.handleLoader = () => {
            store_1.reportsStore.showLoader = !store_1.reportsStore.showLoader;
        };
        this.handleChangeSite = (e) => {
            let arr = [];
            if (e.length > 0 && e[0] !== 0) {
                e.map((item) => {
                    arr.push(Number(item.value));
                });
            }
            this.siteId = arr[0] !== 0 ? arr : [0];
            this.selectedValue = e;
        };
        this.loadSites = throttle_debounce_1.debounce(200, (filterText) => {
            const keyword = filterText ? filterText : "";
            const options = {
                count: 100,
                search: keyword,
                start: 0,
                where: ""
            };
            store_2.sitesListStore.loadSitesNoRelation(options);
        });
        this.getMultiSelectValues = () => {
            var _a;
            let selectedItems = [];
            this.siteId && ((_a = this.siteId) === null || _a === void 0 ? void 0 : _a.map(site => {
                if (site == 0) {
                    selectedItems = [];
                    const item = {
                        id: 0,
                        label: "All Pharmacies",
                        value: "0",
                        tokenLabel: "All Pharmacies"
                    };
                    selectedItems.push(item);
                    return selectedItems;
                }
            }));
            this.siteId &&
                store_2.sitesListStore.sites.value.filter(site => { var _a; return (_a = this.siteId) === null || _a === void 0 ? void 0 : _a.map((selectedSite, i) => {
                    if (site.id == selectedSite) {
                        const item = {
                            id: site.id,
                            label: site.displayName || site.name,
                            value: String(site.id),
                            tokenLabel: site.displayName || site.name
                        };
                        selectedItems.push(item);
                    }
                }); });
            return selectedItems;
        };
        this.handleChangeClaimStatus = (value) => {
            this.claimStatus = value;
        };
        this.handleShowDisabledSitesToggle = async () => {
            this.showDisabledSites = !this.showDisabledSites;
            if (this.showDisabledSites) {
                await store_2.sitesListStore.loadDeletedSites();
            }
            else {
                await store_2.sitesListStore.loadSitesNoRelation();
            }
        };
        this.handleSubmitQuery = async () => {
            const selectedVal = this.siteId[0] === 0
                ? null
                : this.siteId.length === 0
                    ? null
                    : this.siteId;
            this.handleLoader();
            this.headerToggle();
            await store_1.reportsStore.loadClaimAnalytics(selectedVal, this.claimStatus, this.startDate, this.endDate, this.cashClaimsOnly, true);
            this.selectedValue = [];
        };
        // Too lazy to figure out how to determine  which is which based on e.target.
        // So just rewrote pretty much the same functions for the date picker buttons
        // but for the individual start and end dates.
        this.handleClickTodayStart = () => {
            const date = new Date().toDateString();
            this.startDate = moment(date).format("YYYY-MM-DD");
        };
        this.handleClickTodayEnd = () => {
            const date = new Date().toDateString();
            this.endDate = moment(date).format("YYYY-MM-DD");
        };
        this.handleClickClearStart = () => {
            this.startDate = "";
        };
        this.handleClickClearEnd = () => {
            this.endDate = "";
        };
        this.handleDatePickerChangeStart = (value) => {
            this.startDate = moment(value).format("YYYY-MM-DD");
        };
        this.handleDatePickerChangeEnd = (value) => {
            this.endDate = moment(value).format("YYYY-MM-DD");
        };
        this.handleCancel = () => {
            store_1.reportsStore.editModal = !store_1.reportsStore.editModal;
            if (this.showDisabledSites) {
                this.showDisabledSites = false;
                store_2.sitesListStore.loadSitesNoRelation();
            }
            this.selectedValue = [];
        };
    }
    // B-040 this.siteId[0] !== 0 ? this.siteId.push(usersStore.user.value.siteId) : this.siteId;
    componentWillMount() {
        if (store_3.usersStore.user.value &&
            store_3.usersStore.user.value.siteUser &&
            store_3.usersStore.user.value.siteId) {
            this.siteId[0] !== 0
                ? this.siteId.push(store_3.usersStore.user.value.siteId)
                : this.siteId;
        }
        else {
            store_2.sitesListStore.loadSitesNoRelation();
        }
    }
    /**
     * E-031, B-040 const isImbUser = usersStore.user.value.hasOwnProperty('user');
     */
    get availableOptions() {
        var _a, _b;
        const options = [];
        // const isImbUser = usersStore.user.value.user;
        const isImbUser = store_3.usersStore.user.value.hasOwnProperty("user");
        if (isImbUser) {
            if (store_2.sitesListStore.sites.value) {
                options.push({
                    id: 0,
                    label: "All Pharmacies",
                    value: "0",
                    tokenLabel: "All Pharmacies"
                });
                store_2.sitesListStore.sites.value.forEach((site, i) => {
                    const indexStandardizer = 1;
                    options.push({
                        id: i + indexStandardizer,
                        label: site.displayName || site.name,
                        value: site.id.toString(),
                        disable: site.live,
                        tokenLabel: site.displayName || site.name
                    });
                });
                let selectedValue = this.getMultiSelectValues();
                for (var i = options.length - 1; i >= 0; i--) {
                    for (var j = 0; j < selectedValue.length; j++) {
                        if (options[i] && options[i].value === selectedValue[j].value) {
                            options.splice(i, 1);
                        }
                    }
                }
                if (selectedValue.length) {
                    if (selectedValue[0].id !== 0 &&
                        selectedValue[0].label !== "All Pharmacies") {
                        options.splice(0, 1);
                    }
                }
            }
        }
        else {
            const { site } = store_3.usersStore.user.value;
            const siteOption = {
                id: site.id,
                label: (_a = site.displayName) !== null && _a !== void 0 ? _a : site.name,
                value: site.id.toString(),
                disable: site.live,
                tokenLabel: (_b = site.displayName) !== null && _b !== void 0 ? _b : site.name
            };
            options.push(siteOption);
        }
        return options;
    }
    render() {
        var _a, _b, _c;
        const { label = "Search", title, withDatePicker } = this.props;
        const buttons = [];
        buttons.push(React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"), React.createElement(button_1.MaterialButton, { className: "btnSubmit", onClick: this.handleSubmitQuery, primary: true, style: { marginLeft: "1em" } }, "Submit"));
        const permissionToViewDisabledSites = store_3.usersStore.permissions.ViewDisabledSites;
        return (React.createElement("div", null,
            React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
                title && (React.createElement("div", { className: "filter-bar__title", style: { margin: "10px" } },
                    React.createElement("div", { className: "filter-bar__title-text" }, title))),
                React.createElement(button_1.MaterialButton, { onClick: () => this.headerToggle(), style: { margin: "10px" } }, "Query Options")),
            store_1.reportsStore.editModal ? (React.createElement(modal_1.Modal, { onCancel: this.headerToggle, height: "fit-content", top: "25%", width: "fit-content", buttons: buttons },
                React.createElement("div", { className: "filter-bar" },
                    React.createElement("div", { style: {
                            pointerEvents: !((_a = store_3.usersStore.user.value) === null || _a === void 0 ? void 0 : _a.distAdmin) &&
                                !((_b = store_3.usersStore.user.value) === null || _b === void 0 ? void 0 : _b.distManager) &&
                                !((_c = store_3.usersStore.user.value) === null || _c === void 0 ? void 0 : _c.distUser)
                                ? ""
                                : "none"
                        } },
                        permissionToViewDisabledSites ? (React.createElement("div", { className: "sites__data__disabled-toggle" },
                            React.createElement(switch_1.MaterialSwitch, { label: "Show Disabled Sites", value: "showDisabledSites", checked: this.showDisabledSites, onChange: this.handleShowDisabledSitesToggle }),
                            React.createElement(switch_1.MaterialSwitch, { label: "View Cash Claims Only", value: "showDisabledSites", checked: this.cashClaimsOnly, onChange: () => {
                                    this.cashClaimsOnly = !this.cashClaimsOnly;
                                } }))) : null,
                        React.createElement("div", { style: { display: "flex" } },
                            React.createElement(multi_select_1.UiMultiSelect, { label: "Pharmacy", name: "claimReport", options: this.availableOptions, values: this.getMultiSelectValues(), onChange: values => this.handleChangeSite(values) }),
                            React.createElement(select_1.MaterialSelect, { options: this.claimStatuses, required: true, searchable: true, label: "Claim Status", onSelect: this.handleChangeClaimStatus, value: String(this.claimStatus) || "", width: "100%" }))),
                    React.createElement("div", { style: { display: "flex" } },
                        withDatePicker && (React.createElement("div", { className: "filter-bar", style: { paddingRight: "1em" } },
                            React.createElement("h3", null, "Start Date: "),
                            React.createElement(date_picker_1.MaterialDatePicker, { className: "filter-bar__date-picker", label: "Start Date", required: true, value: this.startDate || "", onChange: this.handleDatePickerChangeStart }),
                            React.createElement("div", { style: { display: "flex", marginTop: "1em" } },
                                React.createElement(button_1.MaterialButton, { className: "filter-bar__today-button", primary: true, onClick: this.handleClickTodayStart, style: { marginRight: "1em" } }, "Today"),
                                React.createElement(button_1.MaterialButton, { className: "filter-bar__clear-button", onClick: this.handleClickClearStart }, "Clear")))),
                        withDatePicker && (React.createElement("div", { className: "filter-bar" },
                            React.createElement("h3", null, "End Date: "),
                            React.createElement(date_picker_1.MaterialDatePicker, { className: "filter-bar__date-picker", label: "End Date", required: true, value: this.endDate || "", onChange: this.handleDatePickerChangeEnd }),
                            React.createElement("div", { style: { display: "flex", marginTop: "1em" } },
                                React.createElement(button_1.MaterialButton, { className: "filter-bar__today-button", primary: true, onClick: this.handleClickTodayEnd, style: { marginRight: "1em" } }, "Today"),
                                React.createElement(button_1.MaterialButton, { className: "filter-bar__clear-button", onClick: this.handleClickClearEnd }, "Clear")))))))) : null,
            store_1.reportsStore.showLoader ? React.createElement(ui_1.UiLoadingIndicator, null) : null));
    }
};
__decorate([
    mobx_1.observable
], ClaimAnalyticsHeader.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], ClaimAnalyticsHeader.prototype, "filterDate", void 0);
__decorate([
    mobx_1.observable
], ClaimAnalyticsHeader.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], ClaimAnalyticsHeader.prototype, "selectedValue", void 0);
__decorate([
    mobx_1.observable
], ClaimAnalyticsHeader.prototype, "startDate", void 0);
__decorate([
    mobx_1.observable
], ClaimAnalyticsHeader.prototype, "endDate", void 0);
__decorate([
    mobx_1.observable
], ClaimAnalyticsHeader.prototype, "cashClaimsOnly", void 0);
__decorate([
    mobx_1.observable
], ClaimAnalyticsHeader.prototype, "showDisabledSites", void 0);
__decorate([
    mobx_1.observable
], ClaimAnalyticsHeader.prototype, "claimStatus", void 0);
__decorate([
    mobx_1.computed
], ClaimAnalyticsHeader.prototype, "availableOptions", null);
ClaimAnalyticsHeader = __decorate([
    mobx_react_1.observer
], ClaimAnalyticsHeader);
exports.ClaimAnalyticsHeader = ClaimAnalyticsHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/claim-analytics/components/claim-analytics-header/claim-analytics-header.tsx
// module id = 3879
// module chunks = 0